module.exports = __webpack_public_path__ + "static/media/LilNate-FINAL.87abdc6e.gif";